import React, { useState } from 'react';
import DottedButton from '../../ui/DottedButton';
import i18n from '../../utils/i18n';
import GridRow from '../../ui/GridRow';
import s from './styles/imagesUpload.module.scss';
import ImageUploadPopUp from './modules/imageUploadPopUp';
import { FileUploadType } from './types';
import { Control, Controller, useController } from 'react-hook-form';
import Input from '../../ui/Input';
import Card from '../../ui/Card';
import DeleteButton from './modules/deleteButton';
import { IImageDto } from '../../utils/types';
import NotificationInline, { NotificationTypeEnum } from '../../ui/NotificationInline';

export interface IImagesUploadSingle {
    type: FileUploadType;
    control: Control<any>;
    noCard?: boolean;
    name: string;
    defaultAlt?: string;
    fileName?: string;
    required?: boolean;
    srcHandler: (src: string) => string;
}

const ImagesUploadSingle = ({
    type,
    control,
    name,
    defaultAlt = '',
    noCard,
    fileName,
    required = true,
    srcHandler,
}: IImagesUploadSingle) => {
    const [isPopupOpen, togglePopUp] = useState<boolean>(false);
    const { field, fieldState } = useController<{ img: IImageDto }>({
        control,
        // @ts-ignore
        name,
        rules: { required },
    });

    const handleSuccessUpload = (fileName: string) => {
        field.onChange({ src: fileName });
    };

    const handleRemove = () => {
        field.onChange(null);
    };

    const Wrapper = noCard ? 'div' : Card;

    return (
        <div>
            {field.value ? (
                <Wrapper>
                    <GridRow className={s.card} gutter={4}>
                        <GridRow gutter={8} column>
                            <img src={srcHandler(field.value.src)} />
                            <DeleteButton
                                handleDelete={handleRemove}
                                type={FileUploadType.CATEGORY}
                                src={field.value.src}
                            />
                        </GridRow>
                        <GridRow column gutter={8}>
                            <Controller
                                name={`${name}.alt`}
                                control={control}
                                rules={{ required: true }}
                                defaultValue={defaultAlt}
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <Input
                                        value={value}
                                        onChange={onChange}
                                        label={i18n.images.alt}
                                        infoMessage={i18n.images.hintUsedForGoogle}
                                        error={!!error}
                                    />
                                )}
                            />
                            <Controller
                                name={`${name}.title`}
                                control={control}
                                defaultValue={''}
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <Input
                                        value={value}
                                        onChange={onChange}
                                        label={i18n.images.title}
                                        infoMessage={i18n.images.hintUsedForGoogle}
                                        error={!!error}
                                    />
                                )}
                            />
                        </GridRow>
                    </GridRow>
                </Wrapper>
            ) : (
                <>
                    {fieldState.error && (
                        <NotificationInline text={i18n.general.requiredField} type={NotificationTypeEnum.ERROR} />
                    )}
                    <DottedButton className={s.addButton} onClick={() => togglePopUp(true)}>
                        {i18n.images.upload + i18n.images.name}
                    </DottedButton>
                </>
            )}
            {isPopupOpen && (
                <ImageUploadPopUp
                    closePopUp={() => togglePopUp(false)}
                    type={type}
                    handleSuccess={handleSuccessUpload}
                    titleName={i18n.images.name}
                    fileName={fileName || 'category'}
                />
            )}
        </div>
    );
};

export default ImagesUploadSingle;
